import React from "react";
import Particles from "react-particles-js";

const CustomParticles = props => (
  <Particles 
    params={{
      particles: {
        number: {
          value: 50
        },
        line_linked: {
          shadow: {
            enable: false,
            color: "#3CA9D1",
            blur: 3
          }
        }
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onclick: {
            enable: true,
            mode: "push"
          }
        },
        resize: true
      }
    }}
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    }} />
);

export default CustomParticles;



// WEBPACK FOOTER //
// ./src/components/particles.js